export interface AdminUserResponse {
  adminuser: AdminUserData[];
}

export interface AdminUserData {
  email: string;
  role: string;
  first_name: string;
  last_name: string;
  name?: string;
  technician_id: string;
}

export const RolePermissions = {
  canManageAuth: 'manage_auth',
  canManageConcessions: 'manage_concessions',
  canManageOrders: 'manage_orders',
  canViewOrders: 'view_orders'
}

export interface PermissionGroupResponse {
  role: string;
  allowed_groups: string[];
}

export interface RolePermissionGroup {
  role: string;

  canManageAuth: boolean;
  canManageConcessions: boolean;
  canManageOrders: boolean;
  canViewOrders: boolean;
}

export interface CreateAdminRequestData {
  email: string;
  password: string;
  role: string;
  first_name: string;
  last_name: string;
}

export interface CreateAdminResponse {
  created: [
    {
      technician_id: string;
    }
  ];
}

export interface DeleteAdminResponse {
  result: string;
  technician_id: string;
}
